import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { btn } from '../landing/shared';
import { useRawSiteConfig, useReloadSiteConfig } from '../../lib/siteConfig';
import { adminApi, errorText } from './adminApi';

const FIELDS = [
  { key: 'brand_name', label: 'Markenname (BRAND_NAME)' },
  { key: 'brand_initials', label: 'Initialen im Logo (BRAND_INITIALS)' },
  { key: 'next_start', label: 'Nächster Start (nur ohne Automatik)' },
  { key: 'slots_total', label: 'Plätze gesamt (SLOTS_TOTAL)', type: 'number' },
  { key: 'slots_free', label: 'Freie Plätze (nur ohne Automatik)', type: 'number' },
  { key: 'price', label: 'Preis in € (PRICE)', type: 'number' },
  { key: 'checklist_url', label: 'Link zur Checkliste (CHECKLIST_URL)', type: 'url', wide: true },
  { key: 'trustpilot_url', label: 'Trustpilot-Link (TRUSTPILOT_URL)', type: 'url', wide: true },
];

export const SettingsForm = ({ onUnauthorized }) => {
  const config = useRawSiteConfig();
  const reload = useReloadSiteConfig();
  const [values, setValues] = useState(config);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setValues(config); }, [config]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = { ...values };
    ['slots_total', 'slots_free', 'price'].forEach((k) => { payload[k] = Number(payload[k]); });
    try {
      await adminApi().put('/admin/settings', payload);
      await reload();
      toast.success('Einstellungen gespeichert. Sofort live auf der Seite.');
    } catch (err) {
      if (err.response?.status === 401) onUnauthorized();
      else toast.error(errorText(err));
    }
    setBusy(false);
  };

  return (
    <form onSubmit={save} className="rounded-[20px] border border-line bg-white p-6 sm:p-8" data-testid="admin-settings-form">
      <h2 className="font-display text-2xl font-bold text-navy">Einstellungen der Website</h2>
      <label className="mt-6 flex cursor-pointer items-start gap-3 rounded-2xl border border-line p-4 text-sm text-navy">
        <input type="checkbox" checked={!!values.slots_auto} onChange={(e) => setValues((v) => ({ ...v, slots_auto: e.target.checked }))}
               className="mt-0.5 h-5 w-5 accent-brand" data-testid="admin-setting-slots_auto" />
        <span><strong>Plätze automatisch:</strong> Start ist immer der nächste Monat, und jede Woche ist ein Platz weniger frei (Woche 1: Gesamt minus 1, ab Woche 4: Gesamt minus 4, mindestens 1).</span>
      </label>
      <div className="mt-6 grid gap-5 sm:grid-cols-2">
        {FIELDS.map((f) => (
          <div key={f.key} className={f.wide ? 'sm:col-span-2' : ''}>
            <label htmlFor={`set-${f.key}`} className="mb-1.5 block text-sm font-semibold text-navy">{f.label}</label>
            <input id={`set-${f.key}`} type={f.type || 'text'} value={values[f.key] ?? ''} required min={f.type === 'number' ? 0 : undefined}
                   onChange={(e) => setValues((v) => ({ ...v, [f.key]: e.target.value }))}
                   className="block min-h-[48px] w-full rounded-2xl border border-line px-4 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/40"
                   data-testid={`admin-setting-${f.key}`} />
          </div>
        ))}
      </div>
      <button type="submit" disabled={busy} className={`${btn.primary} mt-6`} data-testid="admin-settings-save-btn">
        {busy && <Loader2 size={18} className="animate-spin" aria-hidden="true" />} Speichern
      </button>
    </form>
  );
};
